import { IQuestionOption } from '../types';
import { OPTION_TYPE_WINDOW_TYPE, OPTION_TYPE_VARIATION } from '../constants';

/**
 * Validates if a string is a valid UUID (any version)
 */
const isValidUUID = (str: string): boolean => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(str);
};

/**
 * Determines if an option represents a product selection
 *
 * Rules:
 * - If optionType === OPTION_TYPE_VARIATION (64), it's always a product
 * - If optionType === OPTION_TYPE_WINDOW_TYPE (0) and optionId is a valid UUID, it's a product
 * - Otherwise, it's not a product
 *
 * @param option - The question option to check
 * @returns true if the option is a product, false otherwise
 */
export const isProductOption = (option: IQuestionOption): boolean => {
    if (option.optionType === OPTION_TYPE_VARIATION) {
        return true;
    }

    if (
      option.optionType === OPTION_TYPE_WINDOW_TYPE &&
      option.optionId.length > 7
    ) {
      return true;
    }

    return false;
};

/**
 * Returns the option if it's a product, otherwise returns undefined
 *
 * @param option - The question option to check
 * @returns The option if it's a product, undefined otherwise
 */
export const getProductFromOption = (option?: IQuestionOption): IQuestionOption | undefined => {
    if (!option) return undefined;
    return isProductOption(option) ? option : undefined;
};
